import { useCallback, useMemo, useState } from 'react'

export const usePopover = () => {
  const [popoverElement, setPopoverElement] =
    useState<HTMLButtonElement | null>(null)

  const openPopover = useCallback(
    (target: HTMLButtonElement) => setPopoverElement(target),
    [setPopoverElement]
  )
  const closePopover = useCallback(
    () => setPopoverElement(null),
    [setPopoverElement]
  )
  return useMemo(
    () => ({
      popoverElement,
      openPopover,
      closePopover
    }),
    [
      popoverElement,
      openPopover,
      closePopover
    ]
  )
}
